<template>
  <div class="w-100">
    <!-- NAME -->
    <div class="w-100 mb-4">
      <div class="row">
        <div :class="showLastName ? 'col-6' : 'col-12'">
          <label class="body-3 mb-1 d-block">First Name <span class="font-weight-bold text-danger">*</span></label>
          <input
            type="text"
            @input="saveData('first_name')"
            class="p-2-5 body-2-1 w-100 border-form radius-6"
            :class="{'border-danger': error_form.first_name != ''}"
            placeholder="Jhon"
            v-model="form.first_name" >
          <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.first_name != ''">{{ error_form.first_name }}</p>
        </div>
        <div class="col-6" v-if="showLastName">
          <label class="body-3 mb-1 d-block">Last Name <span v-if="lastNameRequired" class="font-weight-bold text-danger">*</span></label>
          <input
            type="text"
            @input="saveData('last_name')"
            class="p-2-5 body-2-1 w-100 border-form radius-6"
            :class="{'border-danger': error_form.last_name != ''}"
            placeholder="Jhon"
            v-model="form.last_name" >
          <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.last_name != ''">{{ error_form.last_name }}</p>
        </div>
      </div>
    </div>

    <!-- EMAIL & PHONE -->
    <div class="w-100">
      <div class="row">
        <div v-if="showEmail" :class="page_design_type === 'WIDE_VIEW' ? 'col-6' : 'col-12'">
          <!-- EMAIL -->
          <div class="w-100 mb-4">
            <label class="body-3 mb-1 d-block">{{$t('hotel.visitor-detail.email')}} <span v-if="emailRequired" class="font-weight-bold text-danger">*</span></label>
            <div class="position-relative">
              <input
              type="text"
              @input="saveData('email')"
              class="p-2-5 body-2-1 w-100 border-form radius-6"
              :class="{'border-danger': error_form.email != ''}"
              placeholder="email@example.com"
              v-model="form.email" >
              <div class="position-absolute" style="top:12px;right:16px;">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="local_post_office_24px">
                  <path id="icon/maps/local_post_office_24px" fill-rule="evenodd" clip-rule="evenodd" d="M22 6C22 4.90002 21.1 4 20 4H4C2.90002 4 2 4.90002 2 6V18C2 19.1 2.90002 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM12 13L4 8V18H20V8L12 13Z" fill="black" fill-opacity="0.54"/>
                  </g>
                </svg>
              </div>
            </div>
            <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.email != ''">{{ error_form.email }}</p>
          </div>
        </div>
        <div v-if="showPhone" :class="page_design_type === 'WIDE_VIEW' ? 'col-6' : 'col-12'">
          <!-- PHONE -->
          <div class="w-100 mb-4">
            <label class="body-3 mb-1 d-block">{{$t('hotel.visitor-detail.phone-number')}} <span v-if="phoneRequired" class="font-weight-bold text-danger">*</span></label>
            <div class="position-relative w-100 border-form radius-6" :class="{'border-danger': error_form.phone_number != ''}">
              <div class="row no-gutters">
                <div class="col-5 align-self-center">
                  <div class="pr-2 border-r-form" :key="form_key">
                    <v-select
                      class="border-none"
                      :clearable="false"
                      :options="data_option.country"
                      @input="refreshFrom()"
                      label="label"
                      v-model="form.dial_code">
                        <template #search="{ attributes, events }">
                          <input
                            :placeholder="form.dial_code.code ? '' : '+00'"
                            class="vs__search no-focus-border pl-2"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>

                        <template #selected-option="{ dial_code }">
                          <p class="mb-0 body-2-1 ml-1">{{ dial_code }}</p>
                        </template>
                        <template v-slot:option="option">
                          <div class="d-inline-block align-middle mr-2">
                            <country-flag :country='option.code' size='small'/>
                          </div>
                          <p class="mb-0 d-inline-block align-middle body-2-1">{{`${option.code} (${option.dial_code})`}}</p>
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="col-7 align-self-center">
                  <input type="number" @input="saveData('phone_number')" class="w-100 border-none no-focus-border body-2-1 pl-3" placeholder="000 000 000" v-model="form.phone_number" >
                </div>
              </div>
              <div class="position-absolute" style="top:12px;right:16px;">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="phone_24px">
                    <path id="icon/communication/phone_24px" fill-rule="evenodd" clip-rule="evenodd" d="M4 3H7.5C8.04999 3 8.5 3.45001 8.5 4C8.5 5.25 8.70001 6.45001 9.07001 7.57001C9.17999 7.92001 9.09998 8.31 8.82001 8.59L6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.61 14.99 15.86 14.89 16.12 14.89C16.22 14.89 16.33 14.9 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45001 3.45001 3 4 3ZM6.54004 5C6.60004 5.89001 6.75 6.76001 6.99005 7.59L5.79004 8.79001C5.38 7.59 5.12006 6.32001 5.03003 5H6.54004ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02Z" fill="black" fill-opacity="0.54"/>
                  </g>
                </svg>
              </div>
            </div>
            <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.phone_number != ''">{{ error_form.phone_number }}</p>
          </div>
        </div>
      </div>
    </div>

    <template v-if="type == 'ORDER'">
      <!-- TABLE NUMBER & NOTES -->
      <div class="w-100">
        <div class="row">
          <div class="col-12">
            <!-- TABLE NUMBER -->
            <div class="w-100 mb-4">
              <label class="body-3 mb-1 d-block">Table Number <span class="font-weight-bold text-danger">*</span></label>
              <input
                :disabled="getOutketTrxLockTableNumber || getOutletTrxDelivery.use"
                :class="{
                  'input-disabled': getOutketTrxLockTableNumber || getOutletTrxDelivery.use,
                  'border-danger': error_form.table_number != ''
                }"
                type="text"
                @input="saveData('table_number')"
                class="p-2-5 body-2-1 w-100 border-form radius-6"
                v-model="form.table_number" >
              <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="error_form.table_number != ''">{{ error_form.table_number }}</p>
            </div>
          </div>
          <div class="col-12">
            <!-- NOTES -->
            <div class="w-100 mb-4">
              <label class="body-3 mb-1 d-block">Notes</label>
              <textarea
                class="p-2-5 body-2-1 w-100 border-form radius-6"
                rows="3"
                @input="saveData('notes')"
                v-model="form.notes">
              </textarea>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import {mapGetters,mapMutations} from 'vuex';
	import country from "@/data/country"
	import { parsePhoneNumber, parsePhoneNumberFromString ,ParseError  } from 'libphonenumber-js'
  import Inputmask from "inputmask";
	import 'inputmask/dist/inputmask.min.js';
	import 'inputmask/dist/bindings/inputmask.binding.js';
  import CountryFlag from 'vue-country-flag'
  import { validationMixin } from "vuelidate";
  const { required, email } = require("vuelidate/lib/validators");

  export default {
    components:{
      CountryFlag
    },
    inject: {
      posContext: { default: null },
      cartContext: { default: null }
    },
    props: {
      viewtype:{
        type: String,
        default: 'desktop'
      },
      type:{
        type: String,
        default: 'ORDER' //['ORDER','TABLE']
      },
      isContactRequired:{
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        data_option:{
          country: country
        },
        form:{
          first_name: '',
          last_name: '',
		      email: '',
          dial_code: {},
		      phone_number: '',
          notes: '',
          table_number: ''
        },
        error_form:{
          first_name: '',
          last_name: '',
		      phone_number: '',
		      email: '',
          table_number: ''
        },
        form_key: 0
      }
    },
    mixins: [validationMixin],
    validations: {
      form:{
        first_name:{
          required
        },
        email: {
          required,
          email
        },
        phone_number:{
          required
        },
        table_number:{
          required
        }
      }
    },
    computed:{
      ...mapGetters([
        'getMerchant',
        'getOutletTrxCustomerDetail',
        'getOutletTrxTableNumber',
        'getOutletTrxNotes',
        'getOutletTrxDelivery',
        'getOutketTrxLockTableNumber'
      ]),
      is_mobile_view(){
        return this.viewtype == 'mobile'
      },
      isEmailPhoneRequired(){
        return this.type == 'TABLE' || (this.type == 'ORDER' && this.isContactRequired)
      },
      // Outlet order form setting (MerchantPos.order_form_* : HIDE / SHOW / REQUIRED), default SHOW.
      // Only applies to the Outlet ORDER form; table reservation keeps its own rules.
      orderFormSetting(){
        // table reservation keeps its own rules; the Outlet order form setting does not apply
        if (this.type == 'TABLE') return { last_name: 'SHOW', email: 'SHOW', phone_number: 'SHOW' }
        let general_data = {}
        if (this.cartContext) general_data = this.cartContext.general_data
        else if (this.posContext) general_data = this.posContext.general_data
        general_data = general_data || {}
        return {
          last_name: general_data.order_form_last_name || 'SHOW',
          email: general_data.order_form_email || 'SHOW',
          phone_number: general_data.order_form_phone_number || 'SHOW'
        }
      },
      showLastName(){ return this.orderFormSetting.last_name != 'HIDE' },
      showEmail(){ return this.orderFormSetting.email != 'HIDE' || this.isEmailPhoneRequired },
      showPhone(){ return this.orderFormSetting.phone_number != 'HIDE' || this.isEmailPhoneRequired },
      lastNameRequired(){ return this.orderFormSetting.last_name == 'REQUIRED' },
      emailRequired(){ return this.orderFormSetting.email == 'REQUIRED' || this.isEmailPhoneRequired },
      phoneRequired(){ return this.orderFormSetting.phone_number == 'REQUIRED' || this.isEmailPhoneRequired },
      page_design_type() {
        let general_data = {}
        if (this.cartContext) general_data = this.cartContext.general_data
        else if (this.posContext) general_data = this.posContext.general_data

        const page_design = general_data && general_data.page_design ? general_data.page_design : 'MOBILE_VIEW';
        return (page_design === 'WIDE_VIEW' && !this.$is_mobile_view) ? 'WIDE_VIEW' : 'MOBILE_VIEW'
      }
    },
    mounted(){
      this.fillData()
    },
    methods:{
      ...mapMutations([
        'setTrxOutletCustomerDetail',
        'setTrxOutletTableNumber',
        'setTrxOutletNotes'
      ]),
      fillData(){
        this.form.first_name = this.getOutletTrxCustomerDetail.first_name
        this.form.last_name = this.getOutletTrxCustomerDetail.last_name
        this.form.email = this.getOutletTrxCustomerDetail.email
        this.form.phone_number = this.getOutletTrxCustomerDetail.phone_number

        if(this.type == 'ORDER'){
          this.form.table_number = this.getOutletTrxTableNumber
          this.form.notes = this.getOutletTrxNotes
        }

        this.data_option.country = this.data_option.country.map(x=>{
          x.label = `${x.code}/${x.dial_code}`
          return x
        })
        $(document).ready(function(){
          Inputmask().mask(document.querySelectorAll("input"));
        });
        this.form.dial_code = {}
        this.checkPhoneNumber(this.form.phone_number)
        this.clearHiddenFields()
      },
      clearHiddenFields(){
        let cleared = []
        if(!this.showLastName && this.form.last_name){ this.form.last_name = ''; cleared.push({key: 'last_name', value: ''}) }
        if(!this.showEmail && this.form.email){ this.form.email = ''; cleared.push({key: 'email', value: ''}) }
        if(!this.showPhone && this.form.phone_number){ this.form.phone_number = ''; cleared.push({key: 'phone_number', value: ''}) }
        if(cleared.length) this.setTrxOutletCustomerDetail(cleared)
      },
      refreshFrom(){
        this.form_key++
        this.saveData('dial_code')
      },
      checkPhoneNumber(phone_number){
        if(!(phone_number == '#' || phone_number == '' || phone_number == undefined || phone_number == null)){
          try{
            const phone_parsed = parsePhoneNumberFromString(phone_number)
            if (phone_parsed) {
              this.form.dial_code = this.data_option.country.find(x => x.code == phone_parsed.country)
              this.form.phone_number = phone_parsed.nationalNumber
            }else{
              for(let i = 0; i < this.data_option.country.length; i++){
                let el = this.data_option.country[i]
                let check_country = parsePhoneNumber(phone_number,el.code)
                if(check_country.isValid()){
                  this.form.dial_code = this.data_option.country.find(x => x.code == check_country.country)
                  this.form.phone_number = check_country.nationalNumber
                  break;
                }
                if(i+1 == this.data_option.country.length && !check_country.isValid()){
                  console.log("Invalid phone number")
                  this.setTrxOutletCustomerDetail([
                    {key: 'phone_number', value: ''}
                  ])
                  this.form.phone_number = ''
                }
              }
            }
          }catch(err){
            console.log("PHONE NUMBER ERROR :", err.message)
            this.setTrxOutletCustomerDetail([
              {key: 'phone_number', value: ''}
            ])
            this.form.phone_number = ''
          }
        }
      },
      saveData(field){
        let copy_form = this.$deepCopy(this.form)
        let new_value = copy_form[field]
        let params = []
        if(field == 'table_number'){
          this.setTrxOutletTableNumber(new_value)
        }else if(field == 'notes'){
          this.setTrxOutletNotes(new_value)
        }else{
          if(field == 'dial_code') {
            new_value =  `${copy_form[field].dial_code}${copy_form.phone_number}`
          }
          if(field == 'phone_number') new_value = `${copy_form.dial_code.dial_code}${copy_form[field]}`

          params = [
            {key: field == 'dial_code' ? 'phone_number' : field, value: new_value}
          ]
          this.setTrxOutletCustomerDetail(params)
        }
      },
      resetErrorMessage(){
        this.error_form = {
          first_name: '',
          last_name: '',
		      phone_number: '',
		      email: '',
          table_number: ''
        }
      },
      validateForm(){
        return new Promise((success,fail)=>{
          this.resetErrorMessage()
          let form_val = this.$v.form

          // first_name is always required
          if(form_val.first_name.$invalid){
            this.error_form.first_name = 'Please input your first name'
          }

          // table_number required on ORDER (unless delivery)
          if(this.type == 'ORDER'){
            if(!this.getOutletTrxDelivery.use && form_val.table_number.$invalid){
              this.error_form.table_number = 'Please input table number'
            }
          }

          // last_name required based on outlet order form setting
          if(this.lastNameRequired && (this.form.last_name == '' || this.form.last_name == null)){
            this.error_form.last_name = 'Please input your last name'
          }

          // email required if REQUIRED setting or contact needed for payment; otherwise validate format only when filled
          if(this.emailRequired){
            if(form_val.email.$invalid){
              this.error_form.email = this.$t('hotel.visitor-detail.email-warning')
            }
          }else if(this.showEmail && this.form.email != '' && this.form.email != null && !form_val.email.email){
            this.error_form.email = this.$t('hotel.visitor-detail.email-warning')
          }

          // phone required if REQUIRED setting or contact needed for payment
          if(this.phoneRequired){
            let full_pn = `${this.form.dial_code.code}${this.form.phone_number}`
            if(!this.form.dial_code.code){
              this.error_form.phone_number = this.$t('hotel.visitor-detail.country-code-warning')
            }else if(form_val.phone_number.$invalid){
              this.error_form.phone_number = this.$t('hotel.visitor-detail.phone-number-warning')
            }else if(full_pn.length < 10){
              this.error_form.phone_number = this.$t('hotel.visitor-detail.phone-number-invalid')
            }
          }

          let first_name_valid = this.error_form.first_name == ''
          let last_name_valid = this.error_form.last_name == ''
          let table_valid = this.error_form.table_number == ''
          let email_phone_valid = this.error_form.email == '' && this.error_form.phone_number == ''
          let is_all_form_valid = first_name_valid && last_name_valid && table_valid && email_phone_valid

          if(is_all_form_valid) success()
          else fail()
        })
      }
    }
  }
</script>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type=number]{
    -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/concierge/pos/GuestForm.vue